export enum CrudGetter {
    Pending = 'PENDING',
    Saving = 'SAVING',
    Deleting = 'DELETING',
    Data = 'ALL_DATA',
    Detail = 'DETAIL',
    PageInfo = 'PAGE_INFO',
    Sum = 'SUM',
    GroupedData = 'GROUPED_DATA',
}
